import { getInput } from "../../../../../../../components/ui";
import useEntityImageUpload from "../../../../../../../hooks/useEntityImageUpload";

const ImageField = props => {
  const { image, warehouseItemId } = props || {};
  const { uploadEntityImage, deleteEntityImage, loading } =
    useEntityImageUpload({ refetchQueries: ["FetchWarehouseItem"] });

  const handleUpload = async (e, closeModal) => {
    const files = e.files;
    if (files.length) {
      await uploadEntityImage({
        entityType: "warehouse",
        entityId: warehouseItemId,
        file: files[0],
      });
      closeModal();
    }
  };

  const handleDelete = async () => {
    await deleteEntityImage({
      entityType: "warehouse",
      entityId: warehouseItemId,
    });
  };

  const inputProps = {
    ...props,
    onChange: handleUpload,
    handleDelete,
    className: "border-neutral-400",
    variant: "modal",
    value: image,
    loading,
  };

  return (
    <div className="flex items-center bg-neutral-200">
      {getInput(inputProps)}
    </div>
  );
};

const ManageImage = props => {
  const { disabled, warehouseItem } = props;

  const imageInput = {
    disabled,
    name: "image",
    label: "",
    type: "img",
    isMultiSelect: false,
    uploadType: "file(s)",
    text: "Add Image",
    h: "h-[320px]",
    w: "w-full",
    textClassName:
      "bg-white border border-gray-400 px-6 py-2 rounded-md text-[12px]",
    uploadButtonClassName: "px-8 py-2 rounded-md text-[12px]",
    image: warehouseItem?.image,
    warehouseItemId: warehouseItem?.id,
  };

  return <ImageField {...imageInput} />;
};

export default ManageImage;
